import type { BoxProps, StackProps, TypographyProps } from '@mui/material';
import { Box, Stack, styled, Typography } from '@mui/material';

export const StyledTypographyFontMedium = styled(Typography)<TypographyProps>({
  fontSize: '13px'
});

export const StyledDayNumberTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isToday'
})<TypographyProps & { isToday?: boolean }>(({ theme, isToday }) => ({
  lineHeight: 'normal',
  fontSize: '14px',
  fontFamily: 'SourceSansPro-SemiBold',
  marginRight: theme.spacing(1.25),
  ...(isToday
    ? {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%'
      }
    : undefined)
}));

export const StyledDayTypography = styled(Typography)<TypographyProps>({
  lineHeight: 'normal',
  textTransform: 'capitalize',
  marginRight: '5px'
});

export const StyledDayBox = styled(Box)<BoxProps>({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  gap: 0.5,
  px: 1,
  textAlign: 'center'
});

export const StyledEmployeeBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  height: '100%',
  padding: theme.spacing(0, 1)
}));

export const StyledTooltipContentStack = styled(Stack)<StackProps>(
  ({ theme }) => ({
    padding: theme.spacing(2),
    gap: theme.spacing(1)
  })
);

export const StyledKeyTooltipTypography = styled(Typography)<TypographyProps>(
  () => ({
    width: '140px',
    fontFamily: 'SourceSansPro-SemiBold'
  })
);

export const StyledAbsenceBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isExternal'
})<BoxProps & { isExternal?: boolean }>(({ theme, isExternal }) => ({
  width: '100%',

  ...(isExternal
    ? {
        borderBottom: `4px dashed ${theme.palette.warning.main}`
      }
    : {
        backgroundColor: theme.palette.error.main,
        height: theme.spacing(1)
      })
}));

export const StyledDutyCellBox = styled(Box)<BoxProps>(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
}));

export const StyledOpenRequestFunctionBox = styled(Box)<BoxProps>(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1
}));

export const StyledEntityColorIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'functionColor'
})<BoxProps & { functionColor?: string }>(({ theme, functionColor }) => ({
  backgroundColor: functionColor,
  width: theme.spacing(1.5),
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0
}));
